import Dexie, { Table } from 'dexie';
import { Injectable } from '@angular/core';
import { OmixAtlasSummaryAttributes, OmixAtlasesSummaryResponse } from '../../../polly-manage.interfaces';
import { RepositoryListResponseV2, RepositoryResourceV2 } from '../../../modules/omixatlas-module/@core/interfaces';
interface LastUpdate {
  id?: number;
  tableName: string;
  lastUpdated: number;
}
@Injectable({ providedIn: 'root' })
export class OmixAtlasDbService extends Dexie {
  public omixAtlasesData!: Table<RepositoryResourceV2, number>;
  public omixAtlasesSummary!: Table<OmixAtlasSummaryAttributes, number>;
  public lastUpdatedData!: Table<LastUpdate, number>;
  public refreshTime: number = 3 * 60;   // in seconds

  constructor() {
    super('omixAtlases');
    this.version(1).stores({
      omixAtlasesData: '&id',
      omixAtlasesSummary: '&repo_id',
      lastUpdatedData: '++id,&tableName'
    });
  }
  public async getDiff(table: string): Promise<number | null> {
    const lastUpdatedData = await this.lastUpdatedData.where({ tableName: table }).first();
    let difference: number | null = null;
    if (lastUpdatedData && lastUpdatedData.lastUpdated) {
      const currentTime = Date.now();
      difference = (currentTime - lastUpdatedData.lastUpdated) / 1000;
    }
    return difference;
  }
  public async updateLastUpdatedTime(table: string): Promise<void> {
    const lastUpdatedData = await this.lastUpdatedData.where({ tableName: table }).first();
    if (lastUpdatedData && lastUpdatedData.id) {
      this.lastUpdatedData.update(lastUpdatedData.id, { lastUpdated: Date.now() });
    }
    else {
      this.lastUpdatedData.add({ lastUpdated: Date.now(), tableName: table });
    }
  }

  public async getRefreshTime(tableName: string): Promise<number | null> {
    const difference = await this.getDiff(tableName);
    if (difference === null) {
      return null;
    }
    if (difference > this.refreshTime) {
      return 0;
    }
    return (this.refreshTime - difference) * 1000;
  }
  public async getOmixAtlasData(): Promise<RepositoryListResponseV2> {
    const data = await this.omixAtlasesData.toArray();
    return { data } as unknown as RepositoryListResponseV2;
  }
  public async getOmixAtlasSummaryData(): Promise<OmixAtlasesSummaryResponse> {
    const data = await this.omixAtlasesSummary.toArray();
    return { data } as unknown as OmixAtlasesSummaryResponse;
  }
  public clearDb(): void {
    this.delete();
  }
}
